import type { IRenderContext, SvgVisual, Visual } from '@ardoq/yfiles';
import { disposeRoot } from './reactRootsRegistry';

const disposeCallback = (_context: IRenderContext, visual: Visual) => {
  disposeRoot((visual as SvgVisual).svgElement);
  return visual;
};

export { disposeCallback };
